import React, { useState, useEffect } from 'react';

const AboutUs = ({ aboutUs, colorData }) => {
  return (
    <div className="business-context-container  mb-5" style={{borderBottom: `5px solid rgb(157, 165, 244)`, paddingBottom: "60px", paddingTop: "60px"}}>
      <div className="text-center mb-4">
        <div>
          <h2 className="mb-2 poppin">About Us</h2>
        </div>
      </div>
      <div>
        <p style={{ whiteSpace: 'pre-line' }}>
          {aboutUs}
        </p>
      </div>
    </div>
  );
};

export default AboutUs;